import styled from '@emotion/styled';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, IconButton, TextField } from '@mui/material';
import { grey } from '@mui/material/colors';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from '@mui/x-data-grid';

export const QuickSearchToolbar = props => {
  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    props.onSearchSubmit();
  }
  return (
    <Box>
      <HeaderWrapper>
        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            value={props.value}
            onChange={props.onChange}
            size="small"
            label="جست و جو ..."
            InputProps={{
              startAdornment: (
                <IconButton onClick={props.onSearchSubmit}>
                  <SearchIcon fontSize="small" />
                </IconButton>
              ),
              endAdornment: (
                <IconButton
                  title="Clear"
                  aria-label="Clear"
                  size="small"
                  style={{ visibility: props.value ? 'visible' : 'hidden' }}
                  onClick={props.clearSearch}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ),
            }}
          />
        </form>
        {props.addLable ? (
          <AddBtn size="small" variant="contained" onClick={props.onAddClick}>
            {props.addLable}
          </AddBtn>
        ) : null}
      </HeaderWrapper>
      {/*<GridToolbarContainer>*/}
      {/*  <GridToolbarFilterButton sx={{ color: grey[600], ml: 2 }} />*/}
      {/*  <GridToolbarDensitySelector sx={{ color: grey[600], ml: 2 }} />*/}
      {/*  <GridToolbarColumnsButton sx={{ color: grey[600], ml: 2 }} />*/}
      {/*</GridToolbarContainer>*/}
    </Box>
  );
};

const Container = styled(Box)`
  ${({ theme }) => ({
    p: 2,
    pb: 0,
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  })}
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 5px;
  margin: 0.8rem 0 0.5rem 0;

  @media all and (max-width: 600px) {
    margin-top: 15px;
  }
`;

const AddBtn = styled(Button)`
  white-space: nowrap;
  min-width: 130px;
`;
